
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  emits: ['clear'],
  setup(props, { emit }) {
    const clearEvents = () => {
      emit('clear');
    };

    return {
      props,
      clearEvents,
    };
  },
});
